import {
  ExternalSystemAdmin,
  CreateExternalSystemAdminRequest,
  UpdateExternalSystemAdminRequest
} from '../types/externalSystem';
import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

/**
 * Admin-service for ExternalSystem (vareheis-konfig) — mønster fra loadingZoneService.
 */
class ExternalSystemServiceClass {
  private getBaseUrl(): string {
    const userContext = AuthService.getUserDataFromToken();
    if (!userContext) {
      throw new Error('No user context available');
    }
    return `${API_BASE_URL}/${userContext.companyNo}/externalsystems`;
  }

  private async throwOnError(response: Response): Promise<void> {
    if (response.ok) return;
    const errorText = await response.text();
    try {
      const parsed = JSON.parse(errorText);
      if (parsed?.error) throw new Error(parsed.error);
    } catch (e) {
      if (e instanceof Error && e.message && !(e instanceof SyntaxError)) throw e;
    }
    throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
  }

  async getExternalSystems(): Promise<ExternalSystemAdmin[]> {
    const response = await AuthService.authenticatedGet(this.getBaseUrl());
    await this.throwOnError(response);
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  }

  async createExternalSystem(request: CreateExternalSystemAdminRequest): Promise<ExternalSystemAdmin> {
    const response = await AuthService.authenticatedPost(this.getBaseUrl(), request);
    await this.throwOnError(response);
    return await response.json();
  }

  async updateExternalSystem(id: number, request: UpdateExternalSystemAdminRequest): Promise<ExternalSystemAdmin> {
    const response = await AuthService.authenticatedPut(`${this.getBaseUrl()}/${id}`, request);
    await this.throwOnError(response);
    return await response.json();
  }

  async deleteExternalSystem(id: number): Promise<void> {
    const response = await AuthService.authenticatedFetch(`${this.getBaseUrl()}/${id}`, { method: 'DELETE' });
    await this.throwOnError(response);
  }
}

export const externalSystemService = new ExternalSystemServiceClass();
